export const StyledBox = {
    minHeight: '100%',
    position: 'relative',
}
  
export const PagesBox = {
    minWidth: 0,
    width: '100%', 
    marginTop: '61px',
    marginBottom: '16px',
    minHeight: 'calc(100vh - 61px - 16px)',
}
  
export const StyledContainer = {
    minWidth: 0,
    maxWidth: '1860px',
    height: '100%',
}
  